import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Admin from "./pages/Admin";
import { Providers } from "./components/Shared";
import { Toaster } from "./components/ui/toaster";
import { Home, Browse, Company } from "./pages/Pages";
import Join from "./pages/Join";
import Auth from "./pages/AuthPage";
import Checkout, { CheckoutSuccessPage } from "./pages/CheckoutPage";
import Dashboard from "./pages/Dashboard";
import PilotNotJoined from "./pages/PilotNotJoined";
import AnalyticsDashboard from "./pages/AnalyticsDashboard";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import MarketplaceDisclaimer from "./pages/MarketplaceDisclaimer";
import VendorAgreement from "./pages/VendorAgreement";
import RefundPolicy from "./pages/RefundPolicy";
import VendorApply from "./pages/VendorApply";
import SuperAdmin from "./pages/SuperAdmin";
import Footer from "./components/Footer";

function App() {
  // TEMPORARY: Keep admin preview at /admin only; expose customer app at root
  return (
    <div className="min-h-screen bg-[#f5efe6] text-black safe-bottom">
      <Providers>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/browse" element={<Browse />} />
            <Route path="/company/:id" element={<Company />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/join/:invite_token" element={<Join />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/analytics" element={<AnalyticsDashboard />} />
            <Route path="/pilot-not-joined" element={<PilotNotJoined />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/disclaimer" element={<MarketplaceDisclaimer />} />
            <Route path="/vendor-agreement" element={<VendorAgreement />} />
            <Route path="/refund" element={<RefundPolicy />} />
            <Route path="/vendors/apply" element={<VendorApply />} />
            <Route path="/superadmin" element={<SuperAdmin />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </Providers>
      <Toaster />
    </div>
  );
}

export default App;